import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FormControl, Select } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuItem from '@material-ui/core/MenuItem';

import useStyles from '../style';

export const options = [
  {
    value: 1,
    label: 'DIGITS_MODE_MIN_RANGE',
  },
  {
    value: 2,
    label: 'DIGITS_MODE_MAX_RANGE',
  },
];
export default function DigitsModeField({ params, changeParams }) {
  const classes = useStyles();

  return (
    <Grid item xs={12} classes={{ root: classes.grid }}>
      <FormControl classes={{ root: classes.formControl }}>
        <p className={classes.mainSettingsHeader}>
          <FormattedMessage id="base_side" defaultMessage="" />
        </p>
      </FormControl>
      <Select
        MenuProps={{
          style: { zIndex: 2000 },
        }}
        className="settings-input"
        disableUnderline
        inputProps={{ name: 'base_side' }}
        value={params.base_side}
        onChange={event => changeParams(event.target.value, event.target.name)}
        IconComponent={ExpandMoreIcon}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            <FormattedMessage id={option.label} defaultMessage="" />
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
}

DigitsModeField.propTypes = {
  changeParams: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
};
